export default {
  install(app) {
    app.directive('equal-height', {
      mounted(el, binding) {
        const selectors = Array.isArray(binding.value) ? binding.value : [binding.value || '.box'];

        const adjustHeights = () => {
          selectors.forEach((selector) => {
            const elements = Array.from(el.querySelectorAll(selector));
            if (elements.length === 0) return;

            // Reset heights
            elements.forEach((el) => (el.style.height = 'auto'));

            // Find max height
            const maxHeight = Math.max(...elements.map((el) => el.offsetHeight));

            // Set all to max height
            elements.forEach((el) => {
              el.style.height = `${maxHeight}px`;
            });
          });
        };

        // Initial adjust
        setTimeout(() => {
          adjustHeights();
        }, 0); // Ensure it's delayed after initial render

        // On resize
        window.addEventListener('resize', adjustHeights);

        el._adjustHeights = adjustHeights;
      },
      unmounted(el) {
        window.removeEventListener('resize', el._adjustHeights);
      },
    });
  },
};
